<template>
    <div>
        <vue-google-autocomplete
            v-model="formData.address"
            ref="address"
            :id="id"
            classname="form-control"
            placeholder="Entre com o endereço"
            v-on:placechanged="getAddressData"
            country="br"
            :name="field"
            v-on:keypress.enter.prevent="pressEnter"
            autocomplete="off"
        >
        </vue-google-autocomplete>
        <input type="hidden" v-model="formData.lat" :name="field+'_lat'">
        <input type="hidden" v-model="formData.lng" :name="field+'_lng'">
    </div>
</template>
<script>
    import VueGoogleAutocomplete from 'vue-google-autocomplete';

    export default {
        props: ['end', 'fieldName', 'latitude', 'longitude', 'id'],
        components: {
            VueGoogleAutocomplete
        },
        data: function () {
            return {
                address: '',
                value: '',
                field: 'endereco',
                lat: 0,
                lng: 0,
                formData: {
                    address: '',
                    lat: 0,
                    lng: 0,
                    number: '',
                    cep: '',
                    district: '',
                    city: '',
                    addressOnly: '',
                    complement: '',
                    state: '',

                }
            }
        },
        mounted() {
            if (this.fieldName) {
                this.field = this.fieldName;
            }
            if (this.end) {
                this.value = this.end;
                this.$refs.address.update(this.end);
            }
            if (this.latitude) {
                this.lat = this.latitude;
            }
            if (this.longitude) {
                this.lng = this.longitude;
            }
        },
        methods: {
            getAddressData: function (addressData, placeResultData, id) {
                this.address = addressData;
                this.value = placeResultData.formatted_address;
                this.formData.address = placeResultData.formatted_address;
                this.formData.lat = addressData.latitude;
                this.formData.lng = addressData.longitude;

                function getAddressParam(search) {
                    let data = placeResultData.address_components.filter((data) => {
                        if (data.types.indexOf(search) !== -1) {
                            return data;
                        }
                    })[0];

                    if (! data) {
                        return {
                            long_name: '',
                            short_name: ''
                        };
                    }
                    return data;
                }

                this.formData.addressOnly = getAddressParam('route').long_name;
                this.formData.number = getAddressParam('street_number').long_name;
                this.formData.cep = getAddressParam('postal_code').long_name.replace(/[^0-9.]/g, "");
                this.formData.state = getAddressParam('administrative_area_level_1').short_name;
                this.formData.district = getAddressParam('sublocality_level_1').long_name;
                this.formData.city = getAddressParam('administrative_area_level_2').long_name;
            },
            pressEnter (value) {
                // console.log(this.value);
            }
        },
        watch: {
            formData: {
                handler: function() {
                    this.$emit('newgmapdata', [
                        this.formData.address,
                        this.formData.lat,
                        this.formData.lng
                    ]);

                    this.$emit('newgmapdatacomplete', [
                        this.formData.addressOnly,
                        this.formData.number,
                        this.formData.cep,
                        this.formData.state,
                        this.formData.district,
                        this.formData.city
                    ]);
                },
                deep: true
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/GmapInput.vue